const ATTRIBUTION_STORAGE_KEY = "stz_attribution";

/**
 * Captures last-touch UTM params from the current URL into sessionStorage.
 * Overwrites any prior capture so the most recent utm-carrying landing wins.
 */
const INTERNAL_REFERRER_HOSTS = [
  "stanzacal.com",
  "stanza.co",
  "localhost",
  "127.0.0.1",
  "firebaseapp.com",
  "accounts.google.com",
  "appleid.apple.com",
  "login.microsoftonline.com",
  "stripe.com",
];

export function captureUtmAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utm_source = params.get("utm_source");
    if (utm_source) {
      const attribution = {
        utm_source,
        ...(params.get("utm_medium") && { utm_medium: params.get("utm_medium") }),
        ...(params.get("utm_campaign") && { utm_campaign: params.get("utm_campaign") }),
      };
      sessionStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(attribution));
      return;
    }
    // No explicit UTM: derive a referral touch from an external referrer,
    // but never clobber an attribution already captured this session.
    if (sessionStorage.getItem(ATTRIBUTION_STORAGE_KEY)) return;
    if (!document.referrer) return;
    const host = new URL(document.referrer).hostname.toLowerCase();
    if (INTERNAL_REFERRER_HOSTS.some((h) => host === h || host.endsWith(`.${h}`))) return;
    sessionStorage.setItem(
      ATTRIBUTION_STORAGE_KEY,
      JSON.stringify({ utm_source: host.replace(/^www\./, ""), utm_medium: "referral" })
    );
  } catch {
    // Storage unavailable (private mode, quota) — attribution is best-effort.
  }
}

/**
 * Returns the captured last-touch UTM attribution, or undefined when none.
 * @returns {{utm_source: string, utm_medium?: string, utm_campaign?: string} | undefined}
 */
export function getUtmAttribution() {
  try {
    const raw = sessionStorage.getItem(ATTRIBUTION_STORAGE_KEY);
    return raw ? JSON.parse(raw) : undefined;
  } catch {
    return undefined;
  }
}
